const initialState = {
  bulkAssets: [],
};

export default initialState;
